export const SUPPORT_EMAIL = 'support@invoice2go.com';
